"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var FocusIndicators_1 = require("../styles/FocusIndicators");
var PreventUserSelect_1 = require("../styles/PreventUserSelect");
var TabStyles_1 = require("../styles/TabStyles");
var SwitcherTextBase_1 = require("./SwitcherTextBase");
var SelectedToggle;
(function (SelectedToggle) {
    SelectedToggle[SelectedToggle["Left"] = 0] = "Left";
    SelectedToggle[SelectedToggle["Right"] = 1] = "Right";
})(SelectedToggle = exports.SelectedToggle || (exports.SelectedToggle = {}));
exports.SwitcherStyles = {
    container: {
        display: 'flex'
    },
    toggleBase: tslib_1.__assign(tslib_1.__assign({}, PreventUserSelect_1.PreventUserSelect), { alignItems: 'center', borderStyle: 'solid', borderWidth: TabStyles_1.TabStyles.Sizing.BorderWidth, display: 'flex', flexBasis: '100%', justifyContent: 'center', lineHeight: (TabStyles_1.TabStyles.Sizing.RowHeight - TabStyles_1.TabStyles.Sizing.BorderWidth * 2) + 'px', paddingLeft: TabStyles_1.TabStyles.Spacing.MediumSpace, paddingRight: TabStyles_1.TabStyles.Spacing.MediumSpace }),
    selectedToggle: {
        backgroundColor: TabStyles_1.TabStyles.Colors.F8,
        borderColor: TabStyles_1.TabStyles.Colors.F8,
        color: TabStyles_1.TabStyles.Typography.Color.InvertedPrimary,
    },
    unselectedToggle: {
        backgroundColor: TabStyles_1.TabStyles.Colors.F1,
        borderColor: TabStyles_1.TabStyles.Colors.L6,
        color: TabStyles_1.TabStyles.Typography.Color.Primary,
    },
    hoverSelectedToggle: {
        borderColor: TabStyles_1.TabStyles.Colors.L9
    },
    hoverUnselectedToggle: {
        borderColor: TabStyles_1.TabStyles.Colors.L9
    },
    focusSelectedToggle: {
        borderColor: FocusIndicators_1.DefaultFocusIndicator.borderColor,
        boxShadow: FocusIndicators_1.DefaultFocusIndicator.boxShadow,
        position: 'relative',
    },
    focusUnselectedToggle: {
        borderColor: FocusIndicators_1.DefaultFocusIndicator.borderColor,
        boxShadow: FocusIndicators_1.DefaultFocusIndicator.boxShadow,
        position: 'relative',
    },
    activeSelectedToggle: {
        backgroundColor: TabStyles_1.TabStyles.Colors.F8,
        borderColor: TabStyles_1.TabStyles.Colors.L9,
        color: TabStyles_1.TabStyles.Typography.Color.InvertedPrimary,
    },
    activeUnselectedToggle: {
        backgroundColor: TabStyles_1.TabStyles.Colors.F8,
        borderColor: TabStyles_1.TabStyles.Colors.L9,
        color: TabStyles_1.TabStyles.Typography.Color.InvertedPrimary,
    },
    inactiveToggle: {
        backgroundColor: TabStyles_1.TabStyles.Colors.F1,
        borderColor: TabStyles_1.TabStyles.Colors.L6,
        color: TabStyles_1.TabStyles.Typography.Color.Primary,
    },
    firstToggle: {
        borderBottomLeftRadius: TabStyles_1.TabStyles.Sizing.BorderRadius,
        borderTopLeftRadius: TabStyles_1.TabStyles.Sizing.BorderRadius,
    },
    lastToggle: {
        borderBottomRightRadius: TabStyles_1.TabStyles.Sizing.BorderRadius,
        borderTopRightRadius: TabStyles_1.TabStyles.Sizing.BorderRadius,
    }
};
var ToggleTextWidget = /** @class */ (function (_super) {
    tslib_1.__extends(ToggleTextWidget, _super);
    function ToggleTextWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (idx) {
            if (idx === 1) {
                _this.props.handleRightToggleSelected();
            }
            else {
                _this.props.handleLeftToggleSelected();
            }
        };
        return _this;
    }
    ToggleTextWidget.prototype.render = function () {
        return (React.createElement(SwitcherTextBase_1.SwitcherTextBase, { ariaLabel: this.props.ariaLabel, checkedIndex: this.props.selectedToggle === SelectedToggle.Right ? 1 : 0, handleChange: this.handleChange, name: this.props.name, style: tslib_1.__assign(tslib_1.__assign({}, exports.SwitcherStyles), { container: tslib_1.__assign(tslib_1.__assign({}, exports.SwitcherStyles.container), this.props.containerStyle) }), testId: this.props.testId, toggleTexts: [this.props.leftToggleText, this.props.rightToggleText] }));
    };
    return ToggleTextWidget;
}(React.Component));
exports.ToggleTextWidget = ToggleTextWidget;
//# sourceMappingURL=ToggleTextWidget.js.map